import * as mex from "../static/topojsons/mx_mun.json";
import * as _ from "lodash";

export default {
  getStates() {
    const states = [];
    _.forEach(mex.objects.states.geometries, state => {
      states.push(state.properties.state_name);
    });
    return states;
  },
  getMuns(ofState) {
    const municipalities = [];
    const stateInfo = mex.objects.states.geometries.find(state => {
      return state.properties.state_name == ofState;
    });
    const filteredMuns = mex.objects.municipalities.geometries.filter(mun => {
      return mun.properties.state_code === stateInfo.properties.state_code;
    });
    _.forEach(filteredMuns, mun => {
      municipalities.push(mun.properties.mun_name);
    });
    return municipalities;
  }
};
